module.exports = "img{\r\n    height: 100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/about-brand/about-brand.component.css
// module id = ./src/app/components/about-brand/about-brand.component.css
// module chunks = main